module.exports = __webpack_public_path__ + "img/ico_arrow.d51c4cbd.svg";